import { render } from "./arrangeOptForm.vue?vue&type=template&id=26e934c7&scoped=true"
import script from "./arrangeOptForm.vue?vue&type=script&lang=js"
export * from "./arrangeOptForm.vue?vue&type=script&lang=js"

import "./arrangeOptForm.vue?vue&type=style&index=0&id=26e934c7&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e934c7"]])

export default __exports__